import React from 'react';

// Material UI
import Box from '@material-ui/core/Box';
import Check from '@material-ui/icons/Check';
import Warning from '@material-ui/icons/Warning';

// Data
import { DATE_OF_BIRTH_FALLBACK_LABELS, SportTermLookup } from '../../../lib/types';
import { getImportPlayersMessages } from './import-players.messages';
import { successColor, warnTextColor } from '../../../lib/theme';

// Components
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { MessageLines } from '../../_core/_ui/typography.component';
import { Notice } from '../../_core/_ui/icons.component';

interface IDateOfBirthOptionsSummaryProps {
  termLookup: SportTermLookup;
  allowMissing: boolean;
  fallback: DateOfBirthFallback;
  overwrite: boolean;
}

// Carries the column-selection step's date-of-birth overrides forward, so the review table
// states what happens to blank and already-stored dates before the operator confirms.
export const DateOfBirthOptionsSummary: React.FC<IDateOfBirthOptionsSummaryProps> = ({
  termLookup,
  allowMissing,
  fallback,
  overwrite,
}) => {
  const messages = getImportPlayersMessages(termLookup);

  return (
    <Box m={2}>
      <MessageLines>
        <Notice icon={<Check style={{ color: successColor }} />}>
          {allowMissing
            ? <IntlMsg {...messages.noticeMissingDobApplied} values={{ option: DATE_OF_BIRTH_FALLBACK_LABELS[fallback] }} />
            : <IntlMsg {...messages.noticeRequiredDobApplied} />}
        </Notice>
        {/* A blank row overwrites a stored date with the placeholder, so the pairing warns
            rather than confirms. */}
        <Notice icon={overwrite && allowMissing
          ? <Warning style={{ color: warnTextColor }} />
          : <Check style={{ color: successColor }} />}>
          {!overwrite && <IntlMsg {...messages.noticeKeepDobApplied} />}
          {overwrite && <IntlMsg {...(allowMissing ? messages.noticeOverwriteDobPlaceholder : messages.noticeOverwriteDobApplied)} />}
        </Notice>
      </MessageLines>
    </Box>
  );
};
